/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The DIDCOMM Message (sent or received).
 */
export interface DidCommMessage {
    credentials: Truvity.ListCredential;
    files: Truvity.ListFile;
    /** The DID according to [3.1 DID Syntax](https://www.w3.org/TR/did-core/#did-syntax) of [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core). */
    from: string;
    presentations: Truvity.ListPresentation;
    /** The DID according to [3.1 DID Syntax](https://www.w3.org/TR/did-core/#did-syntax) of [Decentralized Identifiers (DIDs) v1.0](https://www.w3.org/TR/did-core). */
    to: string;
}
